module.exports = __webpack_public_path__ + "static/media/diya_desai.74e35a94.png";